<template>
  <div class="root-wrapper">
    <div class="root">
      <div class="layer1">
        <div class="date">{{ date }}</div>
        <div class="txt">{{ txt }}</div>
      </div>
      <div class="layer2"></div>
      <www-picture class="layer3 common-animation-img" :w="515 * 2" :h="310 * 2" :img="img" :noCompress="true" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    date: String,
    txt: String,
    img: String,
  },
};
</script>

<style lang="less" scoped>
.root-wrapper {
  width: 1067px;
}

.root {
  margin: 0 auto;
  height: 354px;
  width: 964px;
  position: relative;

  .layer1 {
    height: 300px;
    width: 868px;
    top: 40px;
    background: linear-gradient(180deg, #f1f3f8 0%, #ffffff 100%);
    box-shadow: 1px 5px 12px #f4f1f0;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 63px;
    box-sizing: border-box;
    position: relative;

    .date {
      font-style: normal;
      font-weight: 400;
      font-size: 28px;
      line-height: 30px;
      color: #2b2c2e;
    }

    .txt {
      margin-top: 22px;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #2b2c2e;
      white-space: pre-line;
      max-width: 240px;
    }
  }

  .layer2 {
    height: 88px;
    width: 112px;
    top: 266px;
    left: 852px;
    background: #ff571a;
    mix-blend-mode: normal;
    opacity: 0.7;
    border-radius: 4px;
    position: absolute;
  }

  .layer3 {
    top: 0;
    height: 300px;
    width: 515px;
    left: 405px;
    object-fit: contain;
    position: absolute;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HistoryItem.vue